import Bowser from 'bowser'

export default {
  isMicrosoft () {
    return Bowser.name === 'Microsoft Edge' || Bowser.name === 'Internet Explorer'
  },
  download (resource) {
    if (resource) {
      const contentType = resource.mimeType
      const blob = new Blob([resource.file], {type: contentType})
      this.downloadBlob(blob, resource.filename)
    }
  },
  downloadBlob (blob, name) {
    if (this.isMicrosoft()) {
      window.navigator.msSaveOrOpenBlob(blob, name)
    } else {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = name
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(url)
    }
  },
  contentDispositionToMeta (response) {
    const meta = {}
    const contentDis = response.headers['content-disposition']
    meta.filename = contentDis.substr(contentDis.lastIndexOf('=') + 2).substring(0, contentDis.length - 1)
    meta.filename = meta.filename.substring(0, meta.filename.length - 1)
    meta.mimeType = response.headers['content-type']
    return meta
  },
  getTranslatedRoles (context, roles) {
    const translatedRoles = roles.map(role => {
      if (role.roleOfUser === 'ADMIN') {
        return context.$t('enums.roles.ADMIN')
      } else if (role.roleOfUser === 'CONTACT_PERSON') {
        return context.$t('enums.roles.CONTACT_PERSON')
      } else if (role.roleOfUser === 'POLICY_HOLDER') {
        return context.$t('enums.roles.POLICY_HOLDER')
      }
    })
    return translatedRoles
  },
  validators: {
    isCharactersOnly (value) {
      if (value) {
        const matches = value.match(/[a-zA-ZäöüßÄÖÜ]+/)
        if (matches) {
          return true
        }
      }
      return false
    },
    isValidPassword (value) {
      if (value) {
        const matches = value.match(/^(?=.*[!@#$%^&*_0-9])(?=.{0,}[A-Z])(?=.*[a-zA-Z!@#$%^&*_0-9]).{6,}$/gm)
        if (matches) {
          return true
        }
      }
      return false
    },
    isValidContractNumber (value, vm) {
      const dateOfBirth = vm.regData.dateOfBirth
      if (dateOfBirth && value) {
        const contractNumberPrefix = vm.$moment(dateOfBirth, 'DD.MM.YYYY').format('DDMMYY')
        if ((value.startsWith(contractNumberPrefix) || value.startsWith('222')) && value.length === 12) {
          return true
        }
      }
      return false
    },
    isValidDate (value) {
      if (!value) {
        return true
      }
      let isValidYear = this.$moment(value, 'DD.MM.YYYY', true).isValid()
      let isValidContractYear = (this.$moment(value, 'DD.MM.YYYY', true).year() >= 1900)
      let enteredYear = this.$moment(value, 'DD.MM.YYYY', true).year()
      let currentYear = new Date().getFullYear()
      let validYear = true

      if (enteredYear >= currentYear + 20) {
        validYear = false
      }

      return isValidYear && isValidContractYear && validYear
    },
    isValidDomain (value) {
      var urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i
      if (value) {
        const matches = value.match(urlRegex)
        if (matches) {
          return true
        } else {
          return false
        }
      }
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils.js